import { render } from "./ListCommunication.vue?vue&type=template&id=5a0faea4"
import script from "./ListCommunication.vue?vue&type=script&lang=js"
export * from "./ListCommunication.vue?vue&type=script&lang=js"

import "./ListCommunication.vue?vue&type=style&index=0&id=5a0faea4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__